<button
  class="social-button"
  [attr.data-e2e-id]="e2eId"
  [disabled]="disabled"
  (click)="buttonClick.emit()"
>
  <div [ngSwitch]="isLoading" class="button-content">
    <i2g-icon *ngSwitchCase="false" class="logo" [icon]="icon"> </i2g-icon>
    <i2g-icon
      *ngSwitchCase="true"
      class="logo processing-spinner"
      [icon]="spinnerIcon"
    >
    </i2g-icon>
  </div>
</button>
